let baseUrl;
if (process.env.NODE_ENV === 'production' ) {
  //测试
  // baseUrl = 'https://n834qpwybd.execute-api.cn-north-1.amazonaws.com.cn';
  //正式
  baseUrl = 'https://d1wnobcidb.execute-api.cn-north-1.amazonaws.com.cn';
}else{
  //测试
  // baseUrl = 'https://n834qpwybd.execute-api.cn-north-1.amazonaws.com.cn';
  //正式
  baseUrl = 'https://d1wnobcidb.execute-api.cn-north-1.amazonaws.com.cn';
}
export {baseUrl};


// WEBPACK FOOTER //
// ./src/config/env.js